import { ContentPage } from '../page-factory/content-page';
import { premiumTwinTentPage } from '../pages/page-packages';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    {
      title:
        'Sanskriti Vann Mandapam (Premium Tents) - Elegant Accommodation - Kumbh Sukrit',
    },
    {
      name: 'description',
      content:
        'Stay in our elegant Sanskriti Vann Mandapam (Premium Tents) at Magh Mela 2026. Modern comfort meets traditional charm in these thoughtfully designed accommodations.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/accommodations/premium-twin-tent',
    },
  ];
};

export default function PremiumTwinTentPage() {
  return <ContentPage {...premiumTwinTentPage} />;
}
